module.exports = __webpack_public_path__ + "static/img/44-1.a2ae0a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/44-1.jpg
// module id = hk/n
// module chunks = 0